import React, {FC, useContext, useEffect, useState} from "react";
import Loading from "../../layout/Loading";
import DataTable from "../../components/DataTable";
import {useTranslation} from "react-i18next";
import BGTaskScheduleService from "../../service/BGTaskScheduleService";
import DialogContext from "../../Authentication/DialogContext";
import {TFunction} from "i18next";
import {ConfirmDialogProps} from "../../components/ConfirmDialog";
import ProtectedButton from "../../components/ProtectedButton";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEye} from "@fortawesome/free-regular-svg-icons";
import BGTaskService from "../../service/BGTaskService";

const RecentBGTasksTableComponent: FC<{ row: any, reload: boolean }> = ({row, reload}) => {
    const {t} = useTranslation()
    const [isLoading, setLoading] = useState(true)
    const [bgTasks, setBgTasks] = useState([] as any[])
    const {confirmDialogPropsSetter} = useContext(DialogContext)

    useEffect(() => {
        async function loadData() {
            const recentBgTasks = await BGTaskScheduleService.getRecentBGTasksOfSchedule(row.id, 99)
            setBgTasks(recentBgTasks)
        }

        const timerId = setInterval(loadData, 1000)

        loadData().finally(() => setLoading(false))
        return () => clearInterval(timerId);
    }, [reload, row.id])

    const columns = [
        {
            text: t('id'),
            dataField: 'id',
            classes: 'position-relative',
            sort: true,
            formatter: (cellData: any) => (
                <ProtectedButton variant='link' className='text-decoration-none pl-0 stretched-link text-left' tooltip={t('view')}
                                 onClick={() => showBgTaskDetails(t, cellData, confirmDialogPropsSetter)}>
                    <FontAwesomeIcon icon={faEye}/> {cellData}
                </ProtectedButton>
            ),
        },
        {
            text: t('bgTask.state'),
            dataField: 'state',
            classes: 'position-relative',
            sort: true,
        },
        {
            text: t('bgTask.executed'),
            dataField: 'executed',
            classes: 'position-relative',
            sort: true,
        }
    ]

    const data: any[] = bgTasks.map((bgTask: any) => {
            return {
                id: bgTask.id,
                state: bgTask.state + ` (${bgTask.completion}%)`,
                executed: bgTask.executed,
                type: 'STRING',
            }
        }
    )

    const sizePerPageChoice = [
        {
            text: '10',
            value: 10,
        },
        {
            text: '20',
            value: 20,
        }
    ];

    return (
        <Loading isLoading={isLoading}>
            <DataTable
                data={data}
                columns={columns}
                paginate={true}
                searchable={false}
                striped={true}
                hover={true}
                condensed={true}
                showPaginationAllBtn={false}
                sizePerPageList={sizePerPageChoice}
                noDataIndication={() => <span className='text-center'>{t('bgTaskSchedule.noRecentTasksFound')}</span>}
            />
        </Loading>
    )
}

async function showBgTaskDetails(t: TFunction, bgTaskId: number, confirmDialogPropsSetter: React.Dispatch<any>) {
    const bgTask = await BGTaskService.getByID(bgTaskId)
    const data: any[] = []

    Object.entries(bgTask).forEach(([key, value]) =>
        data.push({
            attribute: key.charAt(0).toUpperCase() + key.slice(1),
            value: value,
            type: 'STRING'
        }))

    const columns = [
        {
            text: t('attribute'),
            dataField: 'attribute',
            classes: 'position-relative',
            sort: true,
        },
        {
            text: t('value'),
            dataField: 'value',
            classes: 'position-relative',
            sort: true,
        },
    ]

    const cancelDialogProps: ConfirmDialogProps = {
        show: true,
        header: t('bgTask.properties', {taskName: bgTaskId}),
        body: <DataTable
            data={data}
            columns={columns}
            searchable={false}
            striped={true}
            hover={false}
            condensed={true}
            noDataIndication={() => <span className='text-center'>{t('bgTaskSchedule.noRecentTasksFound')}</span>}
        />,
        showCancelButton: false,
        submitText: t('ok')
    }

    confirmDialogPropsSetter(cancelDialogProps)
}

export default RecentBGTasksTableComponent
